<div class="modal-header">
  <b class="__title">{{ (formMode === 'edit' ? 'common.updateNote' : 'common.createNote') | translate }} </b>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
  <hr class="simple-separator">
</div>
<div class="modal-body">

  <div class="inner-modal-body">

    <section id="view-content">

      <form [formGroup]="noteForm" *ngIf="noteForm" class="view-form view-scrollable-n-fixed">

        <div class="__view-crollable">

          <section class="description-container">
            <label for="" class="main-label">{{ 'common.writeNote' | translate }}</label>
              <div class="description-container">
                <div class="form-group">
                  <textarea class="form-control"
                    rows="6"
                    formControlName="note"
                    placeholder="{{ 'common.note' | translate }}"
                    [ngClass]="{
                      'is-invalid': !noteForm.get('note').valid && noteForm.get('note').errors?.submitted
                    }">
                  </textarea>
                  <div class="invalid-feedback">
                    {{ noteForm.get('note').errors?.message ? 
                    noteForm.get('note').errors.message :  
                    ("notes.warnings.no-valid" | translate) 
                    }}
                  </div>
                </div>
              </div>
          </section>


          <section class="row-gray-input p-2-bottom p-em" *ngIf="contracts && contracts?.length">
            <label for="" class="main-label">{{ 'common.contractName' | translate }} ({{ 'common.optional' | translate }})</label>
            <mat-form-field>
              <!-- <mat-label>{{ "common.selectContractor" | translate }} </mat-label> -->
              <mat-select formControlName="relatedContract" name="relatedContractId" [compareWith]="compareObjects">
                <mat-option *ngFor="let contract of contracts" [value]="contract">
                  {{ contract.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </section>

        </div><!-- end __view-crollable -->

        <div class="gs">
          <div class="lay lay-md-40 lay-lg-40">
            <section class="row-button __actions gs keep-lay">
              <div class="lay-50 p-10-right hidden">
                <button mat-stroked-button class="md m-r-md" color="primary"
                  [disabled]="loading"
                  (click)="goBack()">
                  <span class="capitalize"> {{ "common.cancel" | translate }} </span>
                </button>
              </div>
              <div class="lay-50">
                <button mat-raised-button class="md" color="primary"
                  [disabled]="loading"
                  (click)="saveOrUpdate(noteForm)">
                  <span class="capitalize"> 
                    {{ (formMode === 'edit' ? 'common.update' : 'common.save')  | translate }} 
                  </span>
                </button>
              </div>
            </section>
          </div>
        </div>

      </form>
    </section>

  </div>
</div>